import { render, staticRenderFns } from "./TableRowCompactComponent.vue?vue&type=template&id=2e740f9e&"
import script from "./TableRowCompactComponent.vue?vue&type=script&lang=js&"
export * from "./TableRowCompactComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports